// extracted by mini-css-extract-plugin
export default {"footer-text-item":"mAZF70It--PaymentsComparisonDisclaimer_footer-text-item__j9Sdt","footerTextItem":"mAZF70It--PaymentsComparisonDisclaimer_footer-text-item__j9Sdt"};